import { FetchApi } from '../../axios';

function getListLanguage(data) {
    return FetchApi('/v1.0/languages', 'get', data)
}

export default{
    getListLanguage
}